/*
 * Copyright (c) 2018 Macrofocus GmbH. All Rights Reserved.
 */
package com.macrofocus.crossplatform.client.layer

import js.typedarrays.Uint8ClampedArray
import kotlinx.browser.window
import org.mkui.canvas.AbstractDensityLayer
import org.mkui.canvas.CanvasRenderingContext2DLayer
import org.mkui.canvas.PaletteProvider
import org.mkui.color.MkColor
import org.mkui.geom.Rectangle
import org.mkui.graphics.IDrawing
import org.mkui.graphics.pressure.Pressure
import org.w3c.dom.Document
import web.canvas.CanvasRenderingContext2D
import web.canvas.ID
import web.html.HTMLCanvasElement
import web.images.ImageData
import web.rendering.RenderingContext

class ElementalDensityGWTLayer(iDrawing: IDrawing, width: Int, height: Int, antialiasing: Boolean, pressure: Pressure, palette: PaletteProvider) :
    AbstractDensityLayer(), CanvasRenderingContext2DLayer {
    private val iDrawing: IDrawing
    private val antialiasing: Boolean
    private var image: ImageData? = null
    private val pressure: Pressure
    private val palette: PaletteProvider
    private val canvas: HTMLCanvasElement

    override fun prepare(width: Int, height: Int) {
        if (iDrawing.isActive && width > 0 && height > 0) {
            resize(width, height)
            //        if(visualLayer.getObjectCount() > 0) {
            iDrawing.draw(g, null, width.toDouble(), height.toDouble(), Rectangle(0, 0, width, height))

            // Map number of hits to colors
            val m = computeMax()
            val min: Double = pressure.transform(1.0)
            val max: Double = pressure.transform(m.toDouble())
            val pixelWriter: Uint8ClampedArray<*> = image!!.data
            val pw = pixelWriter
            val range = max - min
            for (i in 0 until overlay.size) {
                val v: Int = overlay.get(i)
                var s = i * 4
                if (v > 0) {
                    val value: Double
                    value = pressure.transform(v.toDouble())
                    val colorIndex = (value * (palette.palette.colorCount - 1) / range).toInt()
                    //                    pixels[i] = palette.getPalette().getColor(colorIndex).getRGB();
                    val color: MkColor = palette.palette.getColorAt(colorIndex)
//                    val array = arrayOf(color.r.toByte(), color.g.toByte(), color.b.toByte(), color.a.toByte())
//                    pixelWriter.set(array, i * 4)
                    pw[s++] = color.r.toInt().toShort()
                    pw[s++] = color.g.toInt().toShort()
                    pw[s++] = color.b.toInt().toShort()
                    pw[s++] = color.a.toInt().toShort()
                } else {
                    //                    pixels[i] = 0x00FFFFFF;
                    //                    pixelWriter.set(i, 0x00FFFFFF);
//                    val array = arrayOf(255.toByte(), 255.toByte(), 255.toByte(), 0.toByte())
//                    pixelWriter.set(array, i * 4)
                    val c = 255.toShort()
                    val a = 0.toShort()
                    pw[s++] = c
                    pw[s++] = c
                    pw[s++] = c
                    pw[s++] = a
                }
            }
            if (antialiasing) {
                image = createAntiAliasedImage(image)
            }
            if (image != null) {
                val context: RenderingContext? = canvas.getContext(CanvasRenderingContext2D.ID)
                val g: CanvasRenderingContext2D = context.unsafeCast<CanvasRenderingContext2D>()
                g.putImageData(image!!, 0, 0)
            }
        }
    }

    fun resize(width: Int, height: Int) {
        if ((this.width != width || this.height != height) && width > 0 && height > 0) {
            canvas.width = width
            canvas.height = height
            val context: RenderingContext? = canvas.getContext(CanvasRenderingContext2D.ID)
            val g: CanvasRenderingContext2D = context.unsafeCast<CanvasRenderingContext2D>()
            val bufferedImage: ImageData = g.createImageData(width, height)
            val o = IntArray(width * height)
            this.width = width
            this.height = height
            image = bufferedImage
            this.overlay = o
            cx1 = 0
            cy1 = 0
            cx2 = width - 1
            cy2 = height - 1
        } else {
            clear()
        }
    }

    override fun render(g: CanvasRenderingContext2D) {
        if (iDrawing.isActive && image != null) {
            g.drawImage(canvas, 0.0, 0.0)
        }
    }

    private fun createAntiAliasedImage(img: ImageData?): ImageData? {
//        return new AntiAliasingBufferedImageOp().filter(img, null);
        return img
    }

    fun clear() {
        if (image != null) {
            overlay.fill(0)
        }
    }

    fun computeMax(): Int {
        var max = 0
        for (v in overlay) {
            if (v > max) {
                max = v
            }
        }
        return max
    }

    init {
        this.iDrawing = iDrawing
        this.antialiasing = antialiasing
        this.pressure = pressure
        this.palette = palette
        val document: Document = window.document
        canvas = document.createElement("canvas") as HTMLCanvasElement
    }
}